import WaCard from "@awesome.me/webawesome-pro/dist/react/card/index.js";
import type { FeatureCollection } from "geojson";
import React from "react";

import { EstimateResponse, LatLng } from "../../types/journey";
import { JourneyMap } from "../JourneyMap/JourneyMap";

type Props = {
  isMobile: boolean;
  origin: LatLng | null;
  destination: LatLng | null;
  originLabel: string;
  destinationLabel: string;
  estimate: EstimateResponse | null;
  onBoundaryReady: (b: FeatureCollection) => void;
  isEditingOrigin: boolean;
  isEditingDestination: boolean;
  heightMobile?: string;
  heightDesktop?: string;
};

export const JourneyMapCard: React.FC<Props> = ({
  isMobile,
  origin,
  destination,
  originLabel,
  destinationLabel,
  estimate,
  onBoundaryReady,
  isEditingOrigin,
  isEditingDestination,
  heightMobile = "180px",
  heightDesktop = "clamp(360px, 50vh, 500px)",
}) => {
  return (
    <WaCard appearance="plain" className="wa-stack wa-gap-0 no-padding">
      <JourneyMap
        origin={origin}
        destination={destination}
        originLabel={originLabel}
        destinationLabel={destinationLabel}
        estimate={estimate}
        onBoundaryReady={onBoundaryReady}
        showLegend={!isMobile}
        height={isMobile ? heightMobile : heightDesktop}
        isEditingOrigin={isEditingOrigin}
        isEditingDestination={isEditingDestination}
      />
    </WaCard>
  );
};
